export default __webpack_public_path__ + "static/media/rica.8b7db3ad.png";